var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 337,
    height: 140,
    viewBox: "0 0 337 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M336.061 13.0607C336.646 12.4749 336.646 11.5251 336.061 10.9393L326.515 1.3934C325.929 0.807612 324.979 0.807612 324.393 1.3934C323.808 1.97918 323.808 2.92893 324.393 3.51472L332.879 12L324.393 20.4853C323.808 21.0711 323.808 22.0208 324.393 22.6066C324.979 23.1924 325.929 23.1924 326.515 22.6066L336.061 13.0607ZM95 136.5H32V139.5H95V136.5ZM3.5 108V42H0.5V108H3.5ZM32 13.5H335V10.5H32V13.5ZM3.5 42C3.5 26.2599 16.2599 13.5 32 13.5V10.5C14.603 10.5 0.5 24.603 0.5 42H3.5ZM32 136.5C16.2599 136.5 3.5 123.74 3.5 108H0.5C0.5 125.397 14.603 139.5 32 139.5V136.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowProcess);
export default __webpack_public_path__ + "static/media/arrow-process.e3f4a1b59f8d20ca6ec05c6a0e7ac5b2.svg";
export { ForwardRef as ReactComponent };